/**
 * appConfig.ts
 * Konfigurasi branding aplikasi — dibaca dari Firestore appConfig/branding
 * agar bisa diubah dari panel Superadmin tanpa mengubah kode.
 */

export const APP_BRANDING = {
  /** Nama pendek aplikasi */
  name: 'PRADNYA',
  /** Kepanjangan resmi */
  fullName: 'Planning, Reflection, Assessment, and Data for Nurturing Young Achievers',
  /** Deskripsi singkat (hanya untuk metadata internal, TIDAK ditampilkan sebagai tagline) */
  description: 'Jurnal Harian Digital Guru Terpadu',
  /** Versi aplikasi */
  version: '0.1.0',
} as const

export type AppBranding = {
  appName: string
  appFullName: string
  logoUrl: string | null
  logoVersion: number
  updatedAt?: Date
}

/** Default branding jika Firestore belum bisa diakses */
export const DEFAULT_BRANDING: AppBranding = {
  appName: APP_BRANDING.name,
  appFullName: APP_BRANDING.fullName,
  logoUrl: null,
  logoVersion: 0,
}
